export interface IOpcaoFluxoPagamento {
  id: number
  valor: string
  descricao: string
}

export const OPCOES_FLUXO_PAGAMENTO: IOpcaoFluxoPagamento[] = [
  {
    id: 1,
    valor: 'total_a_vista',
    descricao: 'Quero pagar valor total à vista (Pix, boleto ou financiamento)'
  },
  {
    id: 2,
    valor: 'parcelado',
    descricao: 'Quero parcelamento ou múltiplas formas de pagamento'
  }
]

export const OPCOES_FLUXO_PAGAMENTO_MAP = {
  AVISTA: OPCOES_FLUXO_PAGAMENTO[0],
  PARCELADO: OPCOES_FLUXO_PAGAMENTO[1]
} as const
